<template>
  <div class="containter df fdc">
    <div class="bar df aic jcb">
      <div class="bar-title">
        <i
          class="iconfont icon-left"
          style="font-size: 30px; margin-right: 20px"
          @click="$emit('close-export')"
          >&nbsp;</i
        >
        {{ $t("langcfg.txtDataExportTitle") }}
      </div>
      <div class="df aic">
        <el-input
          style="width: 300px; font-size: 25px; margin-right: 10px"
          :placeholder="$t('langcfg.txtNameOrPID')"
          v-model.lazy="namePid"
          @click.native.prevent.stop="handleClick"
          @touchend.native.stop.prevent="handleClick"
        >
        </el-input>
        <el-date-picker
          style="margin-right: 10px"
          v-model="dateRange"
          @change="getPatients"
          class="datePicker"
          type="daterange"
          :picker-options="pickerOptions"
          range-separator="-"
          :start-placeholder="`${$t('langcfg.txtStartDate')}`"
          :end-placeholder="`${$t('langcfg.txtEndDate')}`"
          clear-icon="el-icon-circle-close"
        >
        </el-date-picker>
        <el-select
          style="width: 200px; margin-right: 10px"
          v-model="currentCheckType"
          @change="getPatients(true)"
          :disabled="!isTopographyEnabled || !isDryEyeEnabled"
        >
          <el-option
            v-for="item in checkTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-button @click="exportToUdisk">{{ $t("langcfg.txtExportToUdisk") }}</el-button>
        <el-button @click="exportToSharedFolder">{{
          $t("langcfg.txtExportToSharedFolder")
        }}</el-button>
      </div>
    </div>
    <div class="df" style="height: calc(100% - 200px)">
      <div
        class="df fdc"
        :style="{
          borderRight: '1px solid #909399',
          paddingBottom: '10px',
          width: '50%'
        }"
      >
        <el-table
          ref="patientTable"
          row-key="_id"
          highlight-current-row
          :header-row-style="headerStyle"
          :row-style="rowStyle"
          @current-change="currentPatientChanged"
          :data="patients"
          :style="{
            flexGrow: '1'
          }"
        >
          <span style="color: rgba(255, 255, 255, 0.2)" slot="empty">{{
            $t("langcfg.txtNoData")
          }}</span>
          <el-table-column align="center" width="50">
            <template #header
              ><el-checkbox
                :value="
                  patients.length &&
                  patients.every(({ _id }) => allPatients[_id] && allPatients[_id].check)
                "
                @change="togglePatient($event)"
              ></el-checkbox
            ></template>
            <template slot-scope="scope">
              <el-checkbox
                :value="allPatients[scope.row._id] && allPatients[scope.row._id].check"
                @change="togglePatient($event, scope.row)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('langcfg.txtName')" align="center" prop="firstname">
            <template slot-scope="scope">{{
              scope.row.lastname
                ? `${scope.row.firstname} ${scope.row.lastname}`
                : scope.row.firstname
            }}</template>
          </el-table-column>
          <el-table-column label="PID" align="center" prop="pid">
            <template slot-scope="scope">{{ scope.row.pid }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('langcfg.txtCreationDate')"
            align="center"
            prop="creationdate"
          >
            <template slot-scope="scope">{{ getDate(scope.row.creationdate) }}</template>
          </el-table-column>
          <el-table-column :label="$t('langcfg.txtSex')" align="center" width="140" prop="sex">
            <template slot-scope="scope">{{ getSex(scope.row.sex) }}</template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="prev, pager, next"
          :page-size="pagination.pagelength"
          :total="pagination.total"
          :current-page="pagination.page"
          :background="true"
          @current-change="(page) => (pagination.page = page)"
        ></el-pagination>
      </div>
      <el-table
        ref="recordTable"
        :data="currentPatient.records"
        row-key="_id"
        highlight-current-row
        :header-row-style="headerStyle"
        :row-style="rowStyle"
      >
        <span style="color: rgba(255, 255, 255, 0.2)" slot="empty">{{
          $t("langcfg.txtNoData")
        }}</span>
        <el-table-column align="center" width="50">
          <template #header
            ><el-checkbox
              :value="currentPatient.records.length && currentPatient.records.every((v) => v.check)"
              @change="toggleRecord($event)"
            ></el-checkbox
          ></template>
          <template slot-scope="scope">
            <el-checkbox
              :value="scope.row && scope.row.check"
              @change="toggleRecord($event, scope.row)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column :label="$t('langcfg.txtCheckTime')" align="center">
          <template slot-scope="scope">{{ getDate(scope.row.testtime) }}</template>
        </el-table-column>
        <el-table-column :label="$t('langcfg.txtCheckType')" align="center">
          <template slot-scope="scope">{{ getCheckType(scope.row.checktype) }}</template>
        </el-table-column>
        <el-table-column :label="$t('langcfg.txtEye')" align="center">
          <template slot-scope="scope">{{ (scope.row.eyetype || []).join(",") }}</template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import EVENTS from "../../bus";
import moment from "moment";
import { Size, Message, License } from "../../mixins";
import { getPatients } from "../../services/patient";
import { getAllRecordsOfPatientWithoutContent } from "../../services/record";
import fileSys from "../../fileoprators/fileSystem";
import { getSystemTime } from "../../shared/utils";
import { exportData } from "../../services/export";
export default {
  mixins: [Size, Message, License],
  data() {
    return {
      pagination: {
        page: 1,
        pagelength: 15,
        total: 0
      },
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("langcfg.txtLastWeek"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t("langcfg.txtLastMonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t("langcfg.txtLastThreeMonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t("langcfg.txtClear"),
            onClick(picker) {
              picker.$emit("pick", []);
            }
          }
        ]
      },
      currentCheckType: "",
      checkTypeOptions: [],
      dateRange: [],
      namePid: "",
      patients: [],
      allPatients: {},
      currentPatient: { records: [] }
    };
  },
  computed: {
    headerStyle() {
      return {
        fontSize: "24px",
        background: "transparent",
        height: "50px"
      };
    },
    rowStyle() {
      return {
        fontSize: "25px",
        background: "transparent",
        height: "60px"
      };
    }
  },
  watch: {
    pagination: {
      deep: true,
      immediate: true,
      handler() {
        this.getPatients();
      }
    }
  },
  created() {
    if (this.isTopographyEnabled && this.isDryEyeEnabled) {
      this.checkTypeOptions = [
        {
          value: "dryeye",
          label: this.$t("langcfg.txtDryEye")
        },
        {
          value: "topography",
          label: this.$t("langcfg.txtTopography")
        },
        {
          value: "",
          label: this.$t("langcfg.txtAll")
        }
      ];
    } else {
      if (this.isTopographyEnabled) {
        this.currentCheckType = "topography";
        this.checkTypeOptions = [
          {
            value: "topography",
            label: this.$t("langcfg.txtTopography")
          }
        ];
      } else {
        this.currentCheckType = "dryeye";
        this.checkTypeOptions = [
          {
            value: "dryeye",
            label: this.$t("langcfg.txtDryEye")
          }
        ];
      }
    }
  },
  methods: {
    handleClick() {
      let _this = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, this.namePid, (value) => {
        _this.namePid = value;
        _this.getPatients();
      });
    },
    toggleRecord(e, row) {
      if (row) {
        this.$set(row, "check", e);
        this.$set(
          this.currentPatient,
          "check",
          this.currentPatient.records.some((v) => v.check)
        );
      } else {
        this.$set(this.currentPatient, "check", e);
        this.currentPatient.records.forEach((v) => this.$set(v, "check", e));
      }
    },
    togglePatient(e, row) {
      if (row) {
        this.$set(this.allPatients[row._id], "check", e);
        this.allPatients[row._id].records.forEach((v) => this.$set(v, "check", e));
      } else {
        Object.values(this.patients).forEach(({ _id }) => {
          this.$set(this.allPatients[_id], "check", e);
          this.allPatients[_id].records.forEach((cv) => this.$set(cv, "check", e));
        });
      }
    },
    exportFile(dir) {
      const selectRecords = Object.values(this.allPatients)
        .flatMap((v) => v.records)
        .filter((v) => v.check);
      if (!selectRecords.length) {
        return this.message(this.$t("langcfg.txtSelectExportDataTip"), "error");
      }
      if (selectRecords.length > 50) {
        return this.message(this.$t("langcfg.txtExportBeyondTip"), "warning");
      }
      this.$emit("show-waiting", this.$t("langcfg.txtProccessingData"), null, true);
      const filename = `DEA520Data_${getSystemTime("", "_", "")}.mwl`;
      const path = fileSys.combinePath(dir, filename);
      return setTimeout(
        () =>
          exportData(selectRecords, path)
            .then(() =>
              this.message(
                this.$t("langcfg.txtDataExportSuccessTip", { filename }),
                "success",
                5 * 1000
              )
            )
            .catch(() => this.message(this.$t("langcfg.txtDataExportErrorTip"), "error"))
            .finally(() => this.$emit("hide-waiting")),
        3000
      );
    },
    getSex(sex) {
      switch (sex) {
        case "F":
          return this.$t("langcfg.txtFemale");
        case "M":
          return this.$t("langcfg.txtMale");
        case "O":
          return this.$t("langcfg.txtSexOther");
        case "U":
          return this.$t("langcfg.txtSexUnknown");
        default:
          return "";
      }
    },
    getCheckType(checktype) {
      return checktype === "dryeye"
        ? this.$t("langcfg.txtDryEye")
        : this.$t("langcfg.txtTopography");
    },
    getDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    currentPatientChanged(row) {
      this.$set(this, "currentPatient", this.allPatients[row._id]);
    },
    getPatients(refresh = false) {
      let opt = {
        ...this.pagination,
        sort: {
          creationdate: -1
        },
        search: {
          $or: [
            {
              firstname: this.namePid
            },
            {
              pid: this.namePid
            },
            {
              lastname: this.namePid
            }
          ]
        }
      };
      if (this.dateRange && this.dateRange.length === 2) {
        opt.dateRange = [
          this.dateRange[0].format("YYYY-MM-DD"),
          this.dateRange[1].format("YYYY-MM-DD")
        ];
      }
      getPatients(opt, async (res) => {
        if (res.message === "OK") {
          this.pagination.total = res.allPatientsCount;
          this.patients = res.patients;
          this.allPatients = await this.patients.reduce(async (accPromise, cur) => {
            let acc = await accPromise;
            if (!acc[cur._id]) {
              this.$set(acc, cur._id, {
                ...cur,
                records: await this.getRecords(cur._id),
                check: false
              });
            } else if (refresh) {
              let records = await this.getRecords(cur._id).then((res) =>
                res.map((v) => ({
                  ...v,
                  check: acc[cur._id].records.find((cv) => cv._id === v._id)
                    ? acc[cur._id].records.find((cv) => cv._id === v._id).check
                    : false
                }))
              );
              this.$set(acc, cur._id, {
                ...acc[cur._id],
                records,
                check: records.some((v) => v.check)
              });
            }
            return acc;
          }, Promise.resolve(this.allPatients));

          if (this.patients.length) {
            if (this.currentPatient._id) {
              this.currentPatient = this.allPatients[this.currentPatient._id];
            } else {
              this.currentPatient = this.allPatients[this.patients[0]._id];
            }
            this.$nextTick(() => {
              this.$refs.patientTable.setCurrentRow(this.currentPatient);
            });
          } else {
            this.currentPatient = { records: [] };
          }
        }
      });
    },
    getRecords(patientid) {
      return new Promise((s, j) =>
        getAllRecordsOfPatientWithoutContent(
          patientid,
          {
            checktype: this.currentCheckType
          },
          (res) => {
            if (res.message === "OK") {
              s(res.records);
            } else {
              j(res.error);
            }
          }
        )
      );
    },
    exportToUdisk() {
      const { status, location } = fileSys.isUDiskExits();
      if (!status) {
        this.message(this.$t("langcfg.txtDiskIsMountedFailed"), "error", 10000);
        return;
      }
      return this.exportFile(location);
    },
    exportToSharedFolder() {
      let { ip, folder, username, password, folderInLinux } = window.settings.sharedFolder;
      fileSys.mountSharedFS([`${ip}/${folder}`, `${username}`, `${password}`], (error) => {
        if (error) {
          this.message(this.$t("langcfg.txtSharedFolderMountFailed"), "error", 2000);
        } else {
          return this.exportFile(folderInLinux);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.el-table {
  background: transparent;
}
/deep/ .el-table__body-wrapper {
  overflow: auto;
  height: 100%;
}
.containter {
  background: #2d3039;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  position: absolute;
}
.bar {
  padding: 20px;
  border-bottom: 1px solid #909399;
  font-size: 30px;
  .bar-title {
    font-weight: 700;
  }
}
.el-button {
  background: transparent;
  border: 1px solid gray;
  height: 52px;
  min-width: 125px;
  font-size: 20px;
  padding: 10px;
}
/deep/ .el-input__suffix {
  background: transparent;
}
/deep/ .el-input__inner {
  font-size: 25px;
  .el-input__icon {
    font-size: 25px;
  }
}
/deep/ .el-range-input {
  font-size: 25px;
}
/deep/ .el-checkbox__inner {
  width: 20px;
  height: 20px;
}
/deep/ .el-checkbox__inner::after {
  width: 10px;
  height: 15px;
  top: -3px;
}
.el-pagination {
  display: flex;
  justify-content: center;
}
.el-pagination /deep/ li {
  width: 80px;
  height: 60px;
  font-size: 35px;
  line-height: 60px;
}
.el-pagination /deep/ .el-pager li {
  background-color: @page-background;
  color: white !important;
  border: 1px solid gray;
}
.el-pagination /deep/ button {
  width: 80px;
  height: 60px;
  i::before {
    font-size: 40px;
  }
}
.el-pagination /deep/ .btn-next,
.el-pagination /deep/ .btn-prev {
  background-color: @page-background;
  color: white !important;
  border: 1px solid gray;
}
.el-pagination /deep/ .el-pagination__jump {
  color: white;
  font-size: 4px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/ExportPatientAndRecord.vue